// ############################################################################
// ## FINITE STATE MACHINE ####################################################
// ############################################################################

import {find, matches} from "./framework/voidash.js";

class FSMTransition {
  constructor(currState, input, nextState) {
    this.currState = currState;
    this.input = input;
    this.nextState = nextState;
  }
}

export class FSMTransitionTable {
  constructor(opts) {
    this.opts = opts;
    this.transitions = [];
  }

  addTransition(currState, input, nextState) {
    this.transitions.push(new FSMTransition(currState, input, nextState));
  }

  get(currState, input) {
    const transition = find(this.transitions, t => matches(t, {currState, input}));
    return transition ? transition.nextState : this.opts.invalidState;
  }
}

export class FSM {
  constructor(opts) {
    this.state = 0;
    this.opts = opts;
  }

  input(input) {
    const nextState = this.opts.table.get(this.state, input);
    if(nextState !== FSM.NOOP) {
      this.opts.onTransition(nextState, this.state, input);
      this.state = nextState;
    }
  }
}

FSM.NOOP = -1;
